import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { motion, AnimatePresence } from "framer-motion";
import { icons } from "../../Assets/Icons/icons";
import { assets } from "../../Assets/assets";
import properties from "../../config/properties.json";

const BottomNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showProperties, setShowProperties] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState({
    properties: false,
    ongoing: false,
    upcomming: false,
    completed: false,
  });
  const [hoveredStatus, setHoveredStatus] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const path = useLocation();

  const menuItems = [
    {
      title: "Home",
      path: "/",
    },
    {
      title: "Properties",
    },
    {
      title: "About Us",
      path: "/about",
    },
    {
      title: "Contact Us",
      path: "/contact",
    },
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
        setActiveDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
    setActiveDropdown(false);
    window.scrollTo(0, 0);
  };

  const groupedProperties = {
    ongoing:
      properties?.properties?.filter((p) => p.status === "ongoing") || [],
    upcomming:
      properties?.properties?.filter((p) => p.status === "upcomming") || [],
    completed:
      properties?.properties?.filter((p) => p.status === "completed") || [],
  };

  return (
    <>
      <div className="w-full z-50 shadow-md">
        <div className="flex items-center justify-between xl:px-20 py-2 lg:py-0 px-6 lg:bg-[#2a1a05] bg-white text-white">
          <div className="flex justify-between items-center w-full font-semibold">
            <div
              className="flex lg:hidden items-center"
              onClick={() => {
                navigate("/");
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
            >
              <figure className="h-14 w-16">
                <img
                  className="h-full w-full object-contain"
                  src={assets.navLogo}
                  alt="nav-logo"
                />
              </figure>
              <h1 className="text-primaryTextColor font-bold font-smooch leading-6 w-40 text-2xl">
                SEKHAR <br /> BUILDERS
              </h1>
            </div>
            <div
              onClick={() => setMenuOpen(!menuOpen)}
              className="lg:hidden block text-[#e4e95b] text-3xl"
            >
              {icons.hamburgerIcon}
            </div>
            <ul className="lg:flex items-center hidden text-sm xl:text-base">
              {menuItems.map((item, index) => (
                <li key={index} className={`relative`}>
                  {item.title === "Properties" ? (
                    <div
                      onMouseEnter={() => setShowProperties(true)}
                      onMouseLeave={() => {
                        setShowProperties(false);
                        setHoveredStatus(false);
                      }}
                      className={`cursor-pointer hover:text-[#e4e95b] transition-colors duration-300 relative ${
                        path.pathname.replace("/", "") === item.path &&
                        "text-[#e4e95b]"
                      } ${
                        index === 0 ? "border-l border-r" : "border-r"
                      }  border-gray-600 items-center`}
                    >
                      <span className="py-3 px-5 flex items-center gap-1">
                        {item.title}
                        <span
                          className={`${
                            showProperties
                              ? "rotate-180 transition-all duration-500"
                              : "rotate-0 transition-all duration-500"
                          }`}
                        >
                          {icons.angleDownIcon}
                        </span>
                      </span>

                      <ul
                        className={`bg-[#2a1a05] transition-all duration-300 ${
                          showProperties
                            ? "opacity-100"
                            : "opacity-0 pointer-events-none"
                        } flex flex-col w-full text-white absolute z-50`}
                      >
                        <li
                          onMouseEnter={() => setHoveredStatus("ongoing")}
                          className="py-2 hover:text-[#e4e95b] text-xs font-medium transition-colors duration-300 text-center border-t border-gray-500 capitalize relative"
                        >
                          <div className="flex items-center justify-center gap-1">
                            Ongoing
                            <IoIosArrowDown
                              className={`text-[10px] ${
                                hoveredStatus === "ongoing" ? "-rotate-90" : ""
                              } transition-all duration-300`}
                            />
                          </div>

                          <ul
                            className={`bg-[#2a1a05] border-l border-gray-500 transition-all duration-300 ${
                              hoveredStatus === "ongoing"
                                ? "opacity-100"
                                : "opacity-0 pointer-events-none"
                            } flex flex-col absolute left-full top-0 w-full text-white`}
                          >
                            {groupedProperties.ongoing.length > 0 ? (
                              groupedProperties.ongoing.map((p, i) => (
                                <li
                                  key={i}
                                  onClick={() => {
                                    navigate(`/property-details/${p?.id}`);
                                    window.scrollTo({
                                      left: 600,
                                      top: 0,
                                      behavior: "smooth",
                                    });
                                  }}
                                  className="py-2 hover:text-[#e4e95b] text-xs font-medium transition-colors duration-300 text-center border-t border-gray-500 capitalize px-2"
                                >
                                  {p?.propertyName}
                                </li>
                              ))
                            ) : (
                              <li className="py-2 text-xs font-medium text-center text-gray-400">
                                No ongoing properties
                              </li>
                            )}
                          </ul>
                        </li>
                        {/* upcomming */}
                        <li
                          onMouseEnter={() => setHoveredStatus("upcomming")}
                          className="py-2 hover:text-[#e4e95b] text-xs font-medium transition-colors duration-300 text-center border-t border-gray-500 capitalize relative"
                        >
                          <div className="flex items-center justify-center gap-1">
                            Upcomming
                            <IoIosArrowDown
                              className={`text-[10px] ${
                                hoveredStatus === "upcomming"
                                  ? "-rotate-90"
                                  : ""
                              } transition-all duration-300`}
                            />
                          </div>

                          <ul
                            className={`bg-[#2a1a05] border-l border-gray-500 transition-all duration-300 ${
                              hoveredStatus === "upcomming"
                                ? "opacity-100"
                                : "opacity-0 pointer-events-none"
                            } flex flex-col absolute left-full top-0 w-full text-white`}
                          >
                            {groupedProperties.upcomming.length > 0 ? (
                              groupedProperties.upcomming.map((p, i) => (
                                <li
                                  key={i}
                                  onClick={() => {
                                    navigate(`/property-details/${p?.id}`);
                                    window.scrollTo({
                                      left: 600,
                                      top: 0,
                                      behavior: "smooth",
                                    });
                                  }}
                                  className="py-2 hover:text-[#e4e95b] text-xs font-medium transition-colors duration-300 text-center border-t border-gray-500 capitalize px-2"
                                >
                                  {p?.propertyName}
                                </li>
                              ))
                            ) : (
                              <li className="py-2 text-xs font-medium text-center text-gray-400">
                                No Upcomming properties
                              </li>
                            )}
                          </ul>
                        </li>

                        <li
                          onMouseEnter={() => setHoveredStatus("completed")}
                          className="py-2 hover:text-[#e4e95b] text-xs font-medium transition-colors duration-300 text-center border-t border-gray-500 capitalize relative"
                        >
                          <div className="flex items-center justify-center gap-1">
                            Completed
                            <IoIosArrowDown
                              className={`text-[10px] ${
                                hoveredStatus === "completed"
                                  ? "-rotate-90"
                                  : ""
                              } transition-all duration-300`}
                            />
                          </div>

                          <ul
                            className={`bg-[#2a1a05] border-l border-gray-500 transition-all duration-300 ${
                              hoveredStatus === "completed"
                                ? "opacity-100"
                                : "opacity-0 pointer-events-none"
                            } flex flex-col absolute left-full top-0 w-full text-white`}
                          >
                            {groupedProperties.completed.length > 0 ? (
                              groupedProperties.completed.map((p, i) => (
                                <li
                                  key={i}
                                  onClick={() => {
                                    navigate(`/property-details/${p?.id}`);
                                    window.scrollTo({
                                      left: 600,
                                      top: 0,
                                      behavior: "smooth",
                                    });
                                  }}
                                  className="py-2 hover:text-[#e4e95b] text-xs font-medium transition-colors duration-300 text-center border-t border-gray-500 capitalize whitespace-nowrap px-2"
                                >
                                  {p?.propertyName}
                                </li>
                              ))
                            ) : (
                              <li className="py-2 text-xs font-medium text-center text-gray-400">
                                No completed properties
                              </li>
                            )}
                          </ul>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <span
                      className={`px-5 py-3 hover:text-[#e4e95b] transition-colors duration-300 ${
                        (item.path === "/" && path.pathname === "/") ||
                        (item.path !== "/" &&
                          path.pathname.startsWith(item.path))
                          ? "text-[#e4e95b]"
                          : ""
                      } cursor-pointer ${
                        index === 0 ? "border-l border-r" : "border-r"
                      } border-gray-600`}
                      onClick={() => handleNavigate(item.path)}
                    >
                      {item.title}
                    </span>
                  )}
                </li>
              ))}
            </ul>

            <div className="hidden lg:flex gap-3">
              <button
                onClick={() => handleNavigate("/contact")}
                className="bg-[#E4E95B] text-sm hidden xl:block md:text-base hover:bg-white text-black transition-colors duration-300 px-6 py-2 rounded-md"
              >
                Let's Connect
              </button>
            </div>
          </div>
        </div>

        <AnimatePresence>
          {menuOpen && (
            <motion.div
              ref={menuRef}
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ duration: 0.3 }}
              className="fixed overflow-y-auto top-0 right-0 w-2/3 sm:w-1/2 h-full bg-white shadow-lg z-50 p-6 flex flex-col gap-2"
            >
              <div className="flex justify-between items-start mb-4">
                <div className="flex items-center">
                  <figure className="h-16 w-20">
                    <img
                      className="h-full w-full object-contain"
                      src={assets.navLogo}
                      alt="nav-logo"
                    />
                  </figure>
                  <h1 className="text-primaryTextColor font-bold font-smooch leading-6 w-40 text-3xl">
                    SEKHAR <br /> BUILDERS
                  </h1>
                </div>
                <button
                  className="px-3 py-1 text-2xl absolute top-1 right-0 active:text-[#e4e95b] transition-colors duration-300 rounded-md"
                  onClick={() => setMenuOpen(false)}
                >
                  {icons.croseIcon}
                </button>
              </div>

              {menuItems.map((item, index) => (
                <div key={index}>
                  {item.title === "Properties" ? (
                    <div>
                      <div
                        className="flex items-center py-2 border-b-2 border-[#e4e95b] justify-between text-primaryTextColor font-medium cursor-pointer"
                        onClick={() =>
                          setActiveDropdown((prev) => ({
                            ...prev,
                            properties: !prev.properties,
                            ...(prev.properties
                              ? { ongoing: false, completed: false }
                              : {}),
                          }))
                        }
                      >
                        {item.title}
                        <motion.span
                          animate={{
                            rotate: activeDropdown?.properties ? 180 : 0,
                          }}
                          transition={{ duration: 0.3 }}
                        >
                          <IoIosArrowDown />
                        </motion.span>
                      </div>

                      <AnimatePresence>
                        {activeDropdown.properties && (
                          <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.3, ease: "easeInOut" }}
                            className="ml-4 mt-2 space-y-2 overflow-hidden"
                          >
                            <div>
                              <div
                                className="flex items-center justify-between text-sm text-secondaryTextColor font-medium cursor-pointer border-b border-[#e4e95b] py-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setActiveDropdown((prev) => ({
                                    ...prev,
                                    ongoing: !prev.ongoing,
                                    // allow only one status open at a time (optional)
                                    completed: false,
                                    upcomming: false,
                                  }));
                                }}
                              >
                                Ongoing
                                <motion.span
                                  animate={{
                                    rotate: activeDropdown.ongoing ? 180 : 0,
                                  }}
                                  transition={{ duration: 0.3 }}
                                >
                                  <IoIosArrowDown className="text-xs" />
                                </motion.span>
                              </div>

                              <AnimatePresence>
                                {activeDropdown.ongoing && (
                                  <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{
                                      duration: 0.3,
                                      ease: "easeInOut",
                                    }}
                                    className="ml-4 mt-2 space-y-2 overflow-hidden"
                                  >
                                    {groupedProperties.ongoing.length > 0 ? (
                                      groupedProperties.ongoing.map(
                                        (p, idx) => (
                                          <div
                                            key={idx}
                                            className="text-xs text-secondaryTextColor hover:text-primaryColor cursor-pointer border-b border-gray-300 py-2 capitalize"
                                            onClick={() => {
                                              navigate(
                                                `/property-details/${p.id}`
                                              );
                                              setMenuOpen(false);
                                              setActiveDropdown({
                                                properties: false,
                                                ongoing: false,
                                                completed: false,
                                              });
                                              window.scrollTo({
                                                top: 0,
                                                behavior: "smooth",
                                              });
                                            }}
                                          >
                                            {p.propertyName}
                                          </div>
                                        )
                                      )
                                    ) : (
                                      <div className="text-xs text-gray-400 py-2">
                                        No ongoing properties
                                      </div>
                                    )}
                                  </motion.div>
                                )}
                              </AnimatePresence>
                            </div>

                            <div>
                              <div
                                className="flex items-center justify-between text-sm text-secondaryTextColor font-medium cursor-pointer border-b border-[#e4e95b] py-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setActiveDropdown((prev) => ({
                                    ...prev,
                                    upcomming: !prev.ongoing,
                                    // allow only one status open at a time (optional)
                                    completed: false,
                                    ongoing: false,
                                  }));
                                }}
                              >
                                upcomming
                                <motion.span
                                  animate={{
                                    rotate: activeDropdown.upcomming ? 180 : 0,
                                  }}
                                  transition={{ duration: 0.3 }}
                                >
                                  <IoIosArrowDown className="text-xs" />
                                </motion.span>
                              </div>

                              <AnimatePresence>
                                {activeDropdown.upcomming && (
                                  <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{
                                      duration: 0.3,
                                      ease: "easeInOut",
                                    }}
                                    className="ml-4 mt-2 space-y-2 overflow-hidden"
                                  >
                                    {groupedProperties.upcomming.length > 0 ? (
                                      groupedProperties.upcomming.map(
                                        (p, idx) => (
                                          <div
                                            key={idx}
                                            className="text-xs text-secondaryTextColor hover:text-primaryColor cursor-pointer border-b border-gray-300 py-2 capitalize"
                                            onClick={() => {
                                              navigate(
                                                `/property-details/${p.id}`
                                              );
                                              setMenuOpen(false);
                                              setActiveDropdown({
                                                properties: false,
                                                ongoing: false,
                                                upcomming: false,
                                                completed: false,
                                              });
                                              window.scrollTo({
                                                top: 0,
                                                behavior: "smooth",
                                              });
                                            }}
                                          >
                                            {p.propertyName}
                                          </div>
                                        )
                                      )
                                    ) : (
                                      <div className="text-xs text-gray-400 py-2">
                                        No Upcomming properties
                                      </div>
                                    )}
                                  </motion.div>
                                )}
                              </AnimatePresence>
                            </div>

                            <div>
                              <div
                                className="flex items-center justify-between text-sm text-secondaryTextColor font-medium cursor-pointer border-b border-[#e4e95b] py-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setActiveDropdown((prev) => ({
                                    ...prev,
                                    completed: !prev.completed,
                                    // allow only one status open at a time (optional)
                                    ongoing: false,
                                    upcomming: false,
                                  }));
                                }}
                              >
                                Completed
                                <motion.span
                                  animate={{
                                    rotate: activeDropdown.completed ? 180 : 0,
                                  }}
                                  transition={{ duration: 0.3 }}
                                >
                                  <IoIosArrowDown className="text-xs" />
                                </motion.span>
                              </div>

                              <AnimatePresence>
                                {activeDropdown.completed && (
                                  <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{
                                      duration: 0.3,
                                      ease: "easeInOut",
                                    }}
                                    className="ml-4 mt-2 space-y-2 overflow-hidden"
                                  >
                                    {groupedProperties.completed.length > 0 ? (
                                      groupedProperties.completed.map(
                                        (p, idx) => (
                                          <div
                                            key={idx}
                                            className="text-xs text-secondaryTextColor hover:text-primaryColor cursor-pointer border-b border-gray-300 py-2 capitalize"
                                            onClick={() => {
                                              navigate(
                                                `/property-details/${p.id}`
                                              );
                                              setMenuOpen(false);
                                              setActiveDropdown({
                                                properties: false,
                                                ongoing: false,
                                                completed: false,
                                              });
                                              window.scrollTo({
                                                top: 0,
                                                behavior: "smooth",
                                              });
                                            }}
                                          >
                                            {p.propertyName}
                                          </div>
                                        )
                                      )
                                    ) : (
                                      <div className="text-xs text-gray-400 py-2">
                                        No completed properties
                                      </div>
                                    )}
                                  </motion.div>
                                )}
                              </AnimatePresence>
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  ) : (
                    <div
                      className={`text-primaryTextColor border-b-2 py-2 border-[#e4e95b] ${
                        (item.path === "/" && path.pathname === "/") ||
                        (item.path !== "/" &&
                          path.pathname.startsWith(item.path))
                          ? "text-[#e4e95b]"
                          : ""
                      } font-medium cursor-pointer`}
                      onClick={() => handleNavigate(item.path)}
                    >
                      {item.title}
                    </div>
                  )}
                </div>
              ))}

              <button
                onClick={() => handleNavigate("/contact")}
                className="bg-[#E4E95B] mt-5 hover:bg-white text-black transition-colors duration-300 px-6 py-2 rounded-md"
              >
                Let's Connect
              </button>
              <article className="space-y-4 mt-5">
                <div className="flex flex-col sm:flex-row text-center sm:text-left items-center gap-2">
                  <span className="xl:text-3xl text-2xl bg-[#F8F7F3] text-gray-600 p-3 rounded-full">
                    {icons.phoneIcon}
                  </span>
                  <div>
                    <p className="text-gray-500 text-sm">Have any Question?</p>
                    <h1 className="xl:text-xl text-lg font-semibold">
                      +91 9437062040 , +91 9438299105
                    </h1>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row text-center sm:text-left items-center gap-2">
                  <span className="xl:text-3xl text-2xl bg-[#F8F7F3] text-gray-600 p-3 rounded-full">
                    {icons.mailIcon}
                  </span>
                  <div>
                    <p className="text-gray-500 text-sm">Email Us:?</p>
                    <a
                      href="mailto:sekharbuilders@gmail.com
"
                      className="xl:text-xl md:text-lg font-semibold hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer"
                    >
                      sekharbuilders@gmail.com
                    </a>
                  </div>
                </div>
                {/* <ul className="flex justify-center lg:hidden space-x-7">
                  <li>
                    <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
                      {icons.facebookIcon}
                    </span>
                  </li>
                  <li>
                    <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
                      {icons.twitterIcon}
                    </span>
                  </li>
                  <li>
                    <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
                      {icons.instagramIcon}
                    </span>
                  </li>
                  <li>
                    <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
                      {icons.youtubeIcon}
                    </span>
                  </li>
                </ul> */}
              </article>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <div
        className={`bg-black/40 ${
          menuOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        } transition-all duration-300 backdrop-blur-sm top-0 w-full h-full left-0 bottom-0 fixed z-40`}
      ></div>
    </>
  );
};

export default BottomNavbar;
